<template>
  <div>
     <v-dialog v-if=showQuoteEdit v-model="showQuoteEdit" width="70%" persistent transition="dialog-bottom-transition">
    <QuoteEdit :items=itemsSAP @close='showQuoteEdit=false;'></QuoteEdit>
    </v-dialog>
    <div  v-if=dialogLoad>
    <v-dialog
      v-model="dialogLoad"
 persistent
      transition="dialog-bottom-transition"
    >
      <order-purchase-edit @onClose='onClose()'
      @onCloseClear=" 
              onClose();
             itemsSAP=[];
            "
             @clearItems='  itemsSAP=[];'
        :typeOrder=3 :order=order></order-purchase-edit>
    </v-dialog>
</div>

 <s-toolbar search-input label="Requerimientos de Servicio"></s-toolbar>  
   <v-card elevation="0">
      <v-container>
          <v-col style="" class="pt-0">
            <v-row justify="center">
              <v-col lg="3" class="s-col-form">
                <s-select-area label="Filtro por Área" v-model="filter.AreID"> </s-select-area>
              </v-col>
            
            
              <v-col lg="2" class="s-col-form">
                <s-date label="Fecha Inicio" v-model="filter.BeginDate" clearable  ></s-date>
              </v-col>
              <v-col lg="2" class="s-col-form">
                <s-date label="Fecha Fin" v-model="filter.EndDate" clearable  ></s-date>
              </v-col>
            </v-row>
          </v-col>
        </v-container>
   </v-card>

<v-data-table fixed-header :items=itemsDetail v-model="itemsSAP"  height="420" dense show-select item-key="DerID"  :headers=config.headers>
 <template v-slot:item.DerStatus="{item}">
        <v-chip x-small :color="item.DerStatus==7 ?'error':item.DerStatus==6?'primary':''">
          {{item.DerStatus==7 ?'Artículo de Baja':item.DerStatus==6?'Cotizado':'Autorizado' }}
        </v-chip>
      </template>
      <template v-slot:item.ReqAuthorizationDate="{item}">
       {{$moment(item.ReqAuthorizationDate).format('L')}}
      </template>
</v-data-table>

<!--
    <v-row>
      <v-col
        ><s-crud @rowSelected=rowSelected($event)
          :single-row="false"   deleteNoFunction @delete=deleted($event)
          :filter="filterRequirement"
          title="Atención de Requerimientos de Servicios"
          remove
          excel ref="crudAttention"
          pdf
          :config="config"
          height="410"
         add add-no-function
          @add="showDialog()" 
        >
         <template v-slot:options>
        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn small text v-on="on" elevation="0" @click=" showQuoteEdit=true;">
              <v-icon style="font-size:16px;">fas fa-book-reader</v-icon>
            </v-btn>
          </template>
          <span>Generar Solicitud de Cotización</span>
        </v-tooltip>
      </template>
          <template v-slot:filter>
              <v-col style="">
                <v-row justify="center">
                  <v-col lg="3">
                    <s-select-area
                      v-model="filterRequirement.AreID"
                      label="Área"
                    >
                    </s-select-area
                  ></v-col>
         
                  <v-col lg="2">
                    <s-date
                      v-model="filterRequirement.BeginDate" clearable nullable
                      label="Fecha Inicio"
                    ></s-date
                  ></v-col>
                  <v-col lg="2">
                    <s-date clearable
                      v-model="filterRequirement.EndDate" nullable
                      label="Fecha Fin"
                    ></s-date
                  ></v-col>
                </v-row>
              </v-col> </template></s-crud></v-col
    ></v-row>  -->
  </div>
</template>
<script>
import SContactSupplier from '../../../components/Utils/Logistics/SContactSupplier.vue';
import SSupplier from '../../../components/Utils/Logistics/SSupplier.vue';
import _sRequirementDetail from "../../../services/Logistics/RequirementDetailService";
import _sRequirement from "../../../services/Logistics/RequirementService";
import OrderPurchaseEdit from '../OrderPurchase/OrderPurchaseEdit.vue';
import QuoteEdit from "@/views/Logistics/Quote/QuoteEdit.vue";
export default {
  name: "RequirementService",
  components: {SSupplier,SContactSupplier, OrderPurchaseEdit,QuoteEdit},
  props: {model:{type:Boolean,default:false}},

  data:()=> ({TaxCode:null,selectedSAP:[],order:{TypeOrder:3,detail:[]},showQuoteEdit:false,
    itemsConcept:[],itemsAccount:[],AcoID:null,ConID:null,ConName:null,
     SupID:'',Supplier:null,itemsSAP:[],
    dialogLoad: false,
    itemsDetail:[],
    preSelectedItems: [],
    filterRequirement: { BeginDate: null, EndDate: null },
filter: {
   length:-1,
      AreID: 0,
      BeginDate: null,
      EndDate: null,
      TypeRequirement: 3,
      ItmsGrpCod: 0,
      Everybody: 1,
      searchText:''
    },
    config: {
     
      model: {
        DerID: "ID",
        ReqAuthorizationDate: "datetime",
        ReqDate: "datetime",
      },
      service: _sRequirementDetail,
      headers: [
        {text: "N° Requerimiento", value: "ReqDocumentNumber", width:150, },
        { text: "Linea", value: "DerNumLine", sortable: false },
      //  { text: "Solicitud", value: "ReqDate", sortable: false,width:125 },
        { text: "Autorización", value: "ReqAuthorizationDate",width:125 },
        { text: "Descripción", value: "DerDescription",width:600},
      
      
          { text: "Centro de Costo", value: "CceName",width:250 },
        { text: "Linea Negocio", value: "BslName",width:250 },
          { text: "Tipo Costo", value: "TypeCostName" ,width:100},
        { text: "Proyecto", value: "PrjName", width:250},
        { text: "Comentario", value: "DerObservation", sortable: false,width:300},

      ],
    },
  }),
  methods: {
     refresh() {
      this.loading = true;
      _sRequirementDetail
        .pagination(
          { filter: this.filter, searchText: "" },
          this.$fun.getUserID()
        )
        .then((r) => {
          this.loading = false;
          this.itemsDetail = r.data.data;
          this.applySelection();
        });
    },
    change() {
      this.value = this.$fun.getDate();
      if (this.filter.Everybody == 1) {
        this.value = null;
        this.filter.BeginDate = this.value;
        this.filter.EndDate = this.value;
      } else {
        this.filter.BeginDate = this.value;
        this.filter.EndDate = this.value;
      }
      this.clearDate = this.filter.Everybody == 1 ? true : false;
      this.$emit("input", this.value);
    },
    selectItems(itemsToSelect) {
      this.preSelectedItems = itemsToSelect || [];
      this.applySelection();
    },
    applySelection() {
      // Synchronize itemsSAP with preSelectedItems
      // 1. If preSelectedItems is empty, clear itemsSAP (if that's the intention of the caller)
      //    But wait, preSelectedItems comes from the parent's "cart".
      //    If the cart is empty, we should probably uncheck everything in the current view that was in the cart?
      //    Better: The parent sends the CURRENT cart state. We should make sure itemsSAP reflects that.
      
      const selectedIds = new Set(this.preSelectedItems.map((i) => i.DerID));
      
      // Filter out items from itemsSAP that are NO LONGER in the parent's cart (preSelectedItems)
      // BUT, we only want to affect items that *could* be in the cart (i.e., of this type).
      // Since this component only shows Service Requirements, and itemsCard might have mixed types (though we prevent mixing),
      // we can assume items in preSelectedItems for this tab are relevant.
      
      // However, itemsSAP contains items currently "checked" in the grid.
      // If I uncheck something in the grid, it is removed from itemsSAP -> watcher triggers -> removed from parent.
      // If I remove something in parent -> selectItems called -> preSelectedItems updated -> applySelection called.
      
      // So here we want to:
      // A. Add items from preSelectedItems to itemsSAP if they are in itemsDetail (current page) and not already there.
      // B. Remove items from itemsSAP if they are NOT in preSelectedItems.
      
      // Let's rebuild itemsSAP based on overlap between itemsDetail and preSelectedItems?
      // No, itemsSAP might contain items selected from *other* pages if v-data-table preserves selection.
      // But preserving selection across pages usually requires `preserve-state`. 
      // If we assume we only care about visible items or if itemsSAP holds everything...
      
      // Let's assume itemsSAP should include EVERYTHING that is selected.
      // If the parent says "Here is the list of selected items", we should probably just set itemsSAP = matching items?
      
      // Issue: preSelectedItems might have partial data (from other tabs or just ID/desc). 
      // itemsSAP usually needs full objects for the table to render correctly if we use them for other things. 
      // But for just checking the box, ID match is often enough if item-key is set.
      
      // Let's try to match itemsSAP to preSelectedItems.
      // But preSelectedItems has items from the "cart".
      // itemsSAP should be the items from the "cart" that are valid for this component.
      
      // Let's filter preSelectedItems to only those that belong to this "Service" view?
      // Yes, filter by TypeOrder or just assume parent sends right ones? Parent sends ALL itemsCard.
      // Services have TypeOrder = 3? Unsure. Let's check logic.
      // QuoteAttention checks type before adding.
      
      // Safe bet: find items in preSelectedItems that MATCH items in itemsDetail (current view).
      // AND also keep items in itemsSAP that are NOT in itemsDetail? (Preserve other page selections?)
      // If the parent is the source of truth, then itemsSAP should be EXACTLY what matches preSelectedItems.
      
      // Let's try: Set itemsSAP to be the items in preSelectedItems (converted if needed).
      // Since preSelectedItems are the "selected" ones, this seems correct.
      // But preSelectedItems objects might differ slightly from itemsDetail objects.
      // v-data-table compares by reference or item-key. item-key="DerID".
      // So objects with same DerID should work.
      
      this.itemsSAP = [...this.preSelectedItems];
    },
    excel(){
      this.config.service.excel({filter:this.filter}, this.$fun.getUserID(), this.row).then((r) => {
        this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, 'Requerimiento Servicios');
      });
    },
    
    deleted(items){
  items.map((item)=>{
    item.DerStatus=9;
    return item;
  })
  this.$fun.alert('Seguro de Anular?','question').then((r)=>{
    if(r.value)
    _sRequirementDetail.save(items,this.$fun.getUserID()).then(()=>{
      this.$fun.alert('Anulado Correctamente','success');
      this.refresh();
    });
  });
 
},
    onClose(){this.dialogLoad=false; 
    this.refresh();},
    onSave(){},
    showDialog(){
         if(this.model){this.$emit('selected',this.itemsSAP);return;}
        if(this.itemsSAP.length>0){
     
    //  this.itemsSAP=[];
    
   this.order.detail=this.itemsSAP;
      for(let i= 0;i<this.order.detail.length;i++){
        this.order.detail[i].OddDescription=this.order.detail[i].DerDescription;
        this.order.detail[i].OddObservation=this.order.detail[i].DerObservation;
        this.order.detail[i].OddQuantity=1;
        this.order.detail[i].Line=i+1;
        this.order.detail[i].OddAccount=this.order.detail[i].ReqAccount;
      }    
   

   this.dialogLoad=true;
}else this.$fun.alert('No ha seleccionado ningún registro','warning');
    },
     rowClick: function (item, row) {
      this.selectedSAP = [item];
    },
    saveAccount(item){ 
   
if (this.AcoID!=null){
 let edit=    this.itemsSAP.find(x=>x.Line==item.Line);
 let indexEdit= this.itemsSAP.indexOf(item);
 edit.AcoName=this.AcoID.CsaDescription;

this.itemsSAP.splice(indexEdit,1,edit);

}
    },
   
  },
  created() {
   this.filterRequirement.BeginDate = null;
    this.filterRequirement.EndDate = null;
      this.filterRequirement.TypeRequirement=3;

         _sRequirementDetail.pagination({filter:this.filter,searchText:''},this.$fun.getUserID()).then((r)=>{
this.itemsDetail=r.data.data;
   });

  },

    watch:{
    'filter.BeginDate'(){
this.refresh();
    },
    'filter.EndDate'(){
this.refresh();
    },
    'filter.Everybody'(){
this.refresh();
    },
    'filter.ItmsGrpCod'(){
this.refresh();
    },
    'filter.AreID'(){
this.refresh();
    },
    itemsSAP(val) {
      if (this.model) {
        this.$emit('selected', val);
      }
    }
    }
}
</script>
